import { PRODUCT_SUPPORT_PAGE } from "@/data/marketing/capabilityPages";
import SegmentLandingPage from "@/pages/Segments/SegmentLandingPage";

const ProductSupportPage = () => {
  return <SegmentLandingPage content={PRODUCT_SUPPORT_PAGE} />;
};

export default ProductSupportPage;
